import React from 'react';
import styles from './AboutUs.module.css';

const AboutUs = () => {
  const milestones = [
    {
      year: '2019',
      title: 'The Beginning',
      description: 'Started as a small YouTube channel with free Mathematics lectures for UPSC aspirants. Just 2 educators and a vision to make quality education accessible to all.',
      stats: '2 educators',
      color: '#0B5E42'
    },
    {
      year: '2020',
      title: 'First Batch',
      description: 'Launched first paid batch with 47 students. 100% money-back guarantee built trust in the community and proved our commitment.',
      stats: '22 students',
      color: '#1A7A5C'
    },
    {
      year: '2021',
      title: '300+ Students',
      description: 'Crossed 300+ enrolled students. Expanded course offerings and launched BPSC Mathematics Optional program.',
      stats: '1,000+ students',
      color: '#2563EB'
    },
    {
      year: '2022',
      title: '500+ Students',
      description: 'Crossed 500+ enrolled students. Expanded course offerings and launched JPSC,OPSC Mathematics Optional program.',
      stats: '500+ Live Batch Students',
      color: '#8B5CF6'
    },
    {
      year: '2023',
      title: '30,000+ Youtube Community',
      description: 'Reached 30,000+ active learners on Youtube. Launched mobile app and comprehensive test series platform.',
      stats: '10,000+ learners',
      color: '#DC2626'
    },
    {
      year: '2024',
      title: '44,000+ Youtube Community',
      description: 'Reached 44,000+ active learners on Youtube. Launched seperate portal for Exam and CSAT Courses.',
      stats: '44000+ Students',
      color: '#0B5E42'
    },
    {
      year: '2025',
      title: 'Expanding Horizons',
      description: 'Launched CSIR NET and GATE Mathematics courses. Crossed 50,000+ total students across all examinations.',
      stats: '50,000+ students',
      color: '#1A7A5C'
    },
    {
      year: '2026',
      title: '60,000+ Strong',
      description: 'Today, we are a family of 60,000+ aspirants on Youtube, and 100+ Live batch learners.',
      stats: '60,000+ students',
      color: '#FFB800',
      current: true
    }
  ];

  const values = [
    {
      title: 'Student First',
      description: 'Every decision we make is centered around our students\' success and learning experience. Their dreams are our mission.'
    },
    {
      title: 'Quality over Quantity',
      description: 'We focus on deep conceptual clarity rather than rote learning. Understanding over memorization.'
    },
    {
      title: 'Accessible Education',
      description: 'Quality Mathematics education should be affordable and accessible to every aspirant, regardless of their background.'
    },
    {
      title: 'Continuous Innovation',
      description: 'From a YouTube channel to a full-fledged learning platform, we constantly evolve to serve our students better.'
    },
    {
      title: 'Integrity & Transparency',
      description: 'We believe in honest communication, clear pricing, and delivering on our promises.'
    },
    {
      title: 'Lifelong Learning',
      description: 'We are students ourselves, constantly learning and improving to provide the best guidance.'
    }
  ];

  return (
    <div className={styles.aboutPage}>
      {/* Header */}
      <div className={styles.aboutHeader}>
        <div className={styles.container}>
          <h1>Our <span className={styles.gradientText}>Journey</span></h1>
          <p>From a small YouTube channel in 2018 to a community of 60,000+ aspirants in 2026.</p>
        </div>
        <div className={styles.headerWave}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
            <path fill="#EDFFF7" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      <div className={styles.container}>
        {/* Timeline Section */}
        <div className={styles.timelineSection}>
          <div className={styles.sectionHeader}>
            <h2>The Journey So Far</h2>
            <p>Every milestone represents countless hours of learning, teaching, and growing together.</p>
          </div>

          <div className={styles.timeline}>
            {milestones.map((milestone, index) => (
              <div 
                key={index} 
                className={`${styles.timelineItem} ${milestone.current ? styles.currentMilestone : ''}`}
              >
                <div className={styles.timelineYear} style={{ color: milestone.color }}>
                  {milestone.year}
                </div>
                <div className={styles.timelineContent}>
                  <div className={styles.timelineHeader}>
                    <h3>{milestone.title}</h3>
                    <span className={styles.timelineStats}>{milestone.stats}</span>
                  </div>
                  <p>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Our Mission */}
        <div className={styles.missionSection}>
          <div className={styles.missionCard}>
            <h2>Our Mission</h2>
            <p className={styles.missionStatement}>
              To empower every mathematics aspirant in India with world-class education, 
              personalized mentorship, and the confidence to crack the toughest competitive examinations.
            </p>
            <div className={styles.missionGrid}>
              <div className={styles.missionItem}>
                <h4>Quality Education</h4>
                <p>Deliver exceptional mathematics education that builds conceptual clarity and problem-solving skills.</p>
              </div>
              <div className={styles.missionItem}>
                <h4>Affordable Access</h4>
                <p>Make premium coaching accessible to students from all economic backgrounds.</p>
              </div>
              <div className={styles.missionItem}>
                <h4>Results Driven</h4>
                <p>Focus on tangible outcomes — selections in UPSC, BPSC, and other prestigious examinations.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Values */}
        <div className={styles.valuesSection}>
          <div className={styles.sectionHeader}>
            <h2>What Guides Us</h2>
            <p>Our principles haven't changed since day one. They are the foundation of everything we do.</p>
          </div>

          <div className={styles.valuesGrid}>
            {values.map((value, index) => (
              <div key={index} className={styles.valueCard}>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* YouTube Origin Story */}
        <div className={styles.originSection}>
          <div className={styles.originCard}>
            <div className={styles.originContent}>
              <h2>Born from a YouTube Channel</h2>
              <p className={styles.originHighlight}>2019 → 2026</p>
              <p className={styles.originDescription}>
                It started with two educators recording lectures on a phone camera, uploading to YouTube, 
                and responding to every comment personally. Today, those 47 first subscribers have grown 
                to 60,000+ students, but our commitment to each learner remains the same — personal, 
                dedicated, and relentless.
              </p>
              <div className={styles.originStats}>
                <div>
                  <span className={styles.originStatNumber}>60K+</span>
                  <span className={styles.originStatLabel}>YouTube Subscribers</span>
                </div>
                <div>
                  <span className={styles.originStatNumber}>300+</span>
                  <span className={styles.originStatLabel}>Free Lectures</span>
                </div>
                <div>
                  <span className={styles.originStatNumber}>20.1M+</span>
                  <span className={styles.originStatLabel}>Views</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;